import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import AccordionItem from "./AccordionItem";

function FAQ({ name }) {
  const [open, setOpen] = useState(false);

  const toggle = (index) => {
    if (open === index) {
      return setOpen(null);
    }
    setOpen(index);
  };

  const { pathname } = useLocation();
  const pathArray = pathname.split("/").filter(Boolean);

  console.log(pathArray.length);

  let key;

  if (pathArray[0] === "apartments-and-villas-for-sale-in-coimbatore") {
    key = "apartment";
  } else if (pathArray[0] === "plots-for-sale-in-coimbatore") {
    key = "plots";
  } else if (pathArray[0] === "buy-house-in-coimbatore") {
    key = "resale";
  } else if(pathArray[0] === "office-space-for-rent-in-coimbatore") {
    key = "officespace";
  } else if (pathArray.length === 2) {
    key = pathArray[1];
  } else {
    key = pathArray[0];
  }


  const accordionData = {
    //Residential Page
    residential: [
      {
        title: "1. What amenities can I expect in luxury apartments in Coimbatore?",
        content: "At Lands & Lands, we have hundreds of apartments for people with different lifestyles. From a luxury apartment to low-budget apartments, we got properties that provides all the comforts you seek.",
        list1: "Spacious layouts",
        list2: "Modern kitchen appliances",
        list3: "High-quality finishes",
        list4: "24/7 Security",
        list5: "Fitness centres and swimming pools",
        list6: "Landscaped gardens",
      },
      {
        title: "2. How are properties curated, and what criteria are used for selection?",
        content: "Lands & Lands selects properties based on various criteria such as location, quality, market value, and your specific preferences."
      },
      {
        title: "3. Do you have low budget apartments in Coimbatore?",
        content: "Yes, absolutely. At Lands & Lands, we understand the diverse housing needs of people. Our low budget apartments in Coimbatore provide quality living spaces at prices that cater to a variety of budget constraints. "
      },
      {
        title: "4. Do you offer financing or mortgage assistance for new house purchases in Coimbatore?",
        content: "At Lands & Lands, we don’t directly offer financing but we connect you with trusted financial institutions and banks. We can also provide support in negotiating favourable terms such as interest rates and repayment schedules with lenders."
      }
    ],

    apartment: [
      {
        title: "1. What amenities can I expect in luxury apartments in Coimbatore?",
        content: "At Lands & Lands, we have hundreds of apartments for people with different lifestyles. From a luxury apartment to low-budget apartments, we got properties that provides all the comforts you seek.",
        list1: "Spacious layouts",
        list2: "Modern kitchen appliances",
        list3: "High-quality finishes",
        list4: "24/7 Security",
        list5: "Fitness centres and swimming pools",
        list6: "Landscaped gardens",
      },
      {
        title: "2. How are properties curated, and what criteria are used for selection?",
        content: "Lands & Lands selects properties based on various criteria such as location, quality, market value, and your specific preferences."
      },
      {
        title: "3. Do you have low budget apartments in Coimbatore?",
        content: "Yes, absolutely. At Lands & Lands, we understand the diverse housing needs of people. Our low budget apartments in Coimbatore provide quality living spaces at prices that cater to a variety of budget constraints. "
      },
      {
        title: "4. Do you offer financing or mortgage assistance for new house purchases in Coimbatore?",
        content: "At Lands & Lands, we don’t directly offer financing but we connect you with trusted financial institutions and banks. We can also provide support in negotiating favourable terms such as interest rates and repayment schedules with lenders."
      }
    ],
    plots: [
      {
        title: "What types of land are available for purchase in Coimbatore?",
        content: "At Lands & Lands, we have a variety of land options including:",
        list1: "Residential Plots",
        list2: "Commercial Land",
        list3: "Agricultural Land",
        list4: "Industrial Plot",
      },
      {
        title: "Can I get assistance in understanding property documentation and legalitites",
        content: "Yes, absolutely, Our team can guide you onproperty documentation and legal procedures in Coimbatore",
      },
      {
        title: "Are there any broklerage fees included for a property?",
        content: "No, there is no brokerage fee for properties that are not curated by our company. Although we have a 2% brokerage fee that only applies to properties that we have recommended to you.",
      },
      {
        title: "Can I visit the land I'm interested in?",
        content: "Yes, absolutely. We have a structured plan for site visits, which are led by our expert relationship managers. To begin, fill out the inquiry form and one of our team members will get in touch with you. We ensure to schedule a visit at your convenience.",
      },
    ],
    officespace: [
      {
        title: "What are the average rental rates for office spaces in Coimbatore?",
        content: "Rental rates vary depending on the type of space and location. On average, retail spaces can range from 38 to 100 per square foot, while tech parks might go from 6lkh to 12cr",
      },
      {
        title: 'What amenities are commonly available in these office spaces?',
        content: "The amenities may vary based on teh type of space. But the common include-",
        list1: "Parking facilities",
        list2: "24/7 security",
        list3: "High-speed internet",
        list4: "Conference rooms",
        list5: "Cafeteria",
      },
      {
        title: "Are there flexible lease options available?",
        content: "Yes, many landlords offer flexible lease terms to accommodate diverse business needs, such as short-term leases, lease renewals, and scalable space options.",
      },
      {
        title: "How can I find the right office space for my business in Coimbatore?",
        content: "At Lands & Lands, we guide our clients through every stage of the leasing journey. Whether it's exploring commercial buildings or completing the final deal, including all necessary documentation.",
      },
    ],
    resale: [
      {
        title: "What types of land are available for sale in Coimbatore?",
        content: "At Lands & Lands, we offer a diverse range oif land options in Coimbaotre. This includes:",
        list1: "Agricultural Lands",
        list2: "Residential Plots",
        list3: "Commercial parcels",
        list4: "Scenic plots",
      },
      {
        title: "What amenities and utilities are available for the lands listed for sale?",
        content: "The amenities and utilities available vary based on the specific residential land for sale. However, many of our listings have access to essential utilities such as water, electricity, and road connectivity. We ensure transparency in listing the available amenities for each property to assist in your decision-making process.",
      },
      {
        title: "Are the lands legally verified and free from any disputes?",
        content: "Absolutely. At Lands & Lands, our properties are DTCP approved. Before listing any property, we conduct thorough due diligence to ensure that the resale lands in Coimbatore are legally verified, free from disputes, and have clear titles. Your peace of mind and security in your investment are our top priorities.",
      },
      {
        title: " Are there any brokerage fees included for a property?",
        content: "There is no brokerage fee for properties outside our curation. However, our 2% brokerage fee is exclusively applicable to properties recommended by our company.",
      }
    ],
    // End of Residential Page
    //Start of Industries Pages
    retail: [
      {
        title: "How do you identify prime retail locations with good footfall?",
        content: "We use data-driven market analysis including footfall studies, demographic patterns, competitor density mapping, and visibility assessment. Our location intelligence helps identify spots that maximize sales potential from day one of your retail operation."
      },
      {
        title: "Do you work with national retail chains and franchises?",
        content: 'Yes, we have extensive experience with both national and international retail brands. Our corporate clients include major retail chains, and we understand their specific requirements for location, visibility, parking, and infrastructure.'
      },
      {
        title: 'Can you help with lease negotiations and rental agreements?',
        content: "Absolutely! We assist with lease negotiations, ensuring favorable terms for both tenants and landlords. Our team handles rent structuring, escalation clauses, security deposits, and all legal documentation for retail lease agreements."
      },
      {
        title: " How do you ensure good visibility and accessibility for retail properties?",
        content: "We prioritize properties with street-facing visibility, adequate signage possibilities, easy accessibility by foot and vehicle, and proximity to anchor stores or high-traffic generators. Location Matrix evaluation ensures optimal visibility for your retail business."
      },
      {
        title: 'Do you assist with permits and licenses for retail businesses?',
        content: "While we don't directly handle business licenses, we ensure all property-related approvals are in place. We can connect you with experts for trade licenses, fire safety certificates, and other regulatory requirements for retail operations."
      }
    ],
    logistics: [
      {
        title: "What types of logistics properties do you handle?",
        content: "We specialize in warehouses, distribution centers, logistics parks, cold storage facilities, container freight stations, and industrial land for logistics operations. Our inventory includes both lease and purchase options ranging from 10,000 to 50,000+ sq ft.",
      },
      {
        title: "Do you assist with land acquisition for custom logistics facilities?",
        content: "Absolutely! We help acquire industrial land suitable for building custom warehouses and distribution centers. Our services include feasibility studies, soil testing coordination, and ensuring proper zoning and approvals for logistics operations."
      },
      {
        title: "How do you handle compliance and regulatory requirements for logistics properties?",
        content: "Our liaison services ensure all necessary approvals are in place including pollution clearances, fire safety certificates, industrial licenses, and compliance with local municipal regulations. We coordinate with all relevant departments for smooth operations."
      },
      {
        title: "What's the typical size range for logistics properties you deal with?",
        content: "We handle properties ranging from small warehouses (10,,000 sq ft) for local distribution to large logistics parks (100,000+ sq ft) for major supply chain operations. Our portfolio caters to both startups and established logistics companies."
      },
      {
        title: "Can you help with lease agreements for logistics properties?",
        content: 'We assist with lease negotiations including terms specific to logistics operations like loading dock access, operating hours, truck movement permissions, and utility usage clauses. Our team ensures agreements protect your operational needs.'
      },
    ],
    energy: [
      {
        title: "What types of land do you source for solar and wind energy projects?",
        content: "We specialize in large-scale land aggregation for utility-scale solar farms (50+ acres), wind projects (100+ acres), and green hydrogen plants. We focus on locations with optimal solar irradiation, wind speeds, and grid connectivity for renewable energy projects."
      },
      {
        title: " What approvals and clearances do you handle for energy projects?",
        content: "Our liaison services cover environmental clearances, forest clearances (if applicable), pollution board approvals, land use conversion, DTCP permissions, and coordination with electricity boards for grid connection approvals."
      },
      {
        title: " Do you conduct wind and solar resource assessment?",
        content: "While we don't conduct technical assessments ourselves, we coordinate with certified agencies for wind speed studies, solar irradiation measurements, and feasibility studies to ensure optimal site selection for energy projects."
      },
      {
        title: "What about transmission line approvals and right-of-way permissions?",
        content: "Our liaison services include coordination for transmission line approvals, right-of-way permissions from revenue departments, and ensuring clear pathways for power evacuation infrastructure.",
      },
      {
        title: " How do you ensure long-term land security for 25-year energy projects?",
        content: "We ensure proper land documentation, clear titles, long-term lease agreements where applicable, and compliance with all regulatory requirements to provide secure land tenure for the entire project lifecycle.",
      }
    ],
    it: [
      {
        title: "Do your IT properties come with essential infrastructure like high-speed internet?",
        content: "Yes, we prioritize properties with robust IT infrastructure including high-speed internet connectivity, adequate power backup, server room facilities, and telecommunication infrastructure suitable for IT operations."
      },
      {
        title: "How do you ensure properties are located in established IT corridors?",
        content: "We focus on proven IT hubs and emerging corridors with good connectivity, proximity to other tech companies, availability of skilled talent, and infrastructure that supports IT business operations."
      },
      {
        title: "Do you handle compliance and regulatory requirements for IT companies?",
        content: "Our liaison services ensure all necessary approvals are in place including building occupancy certificates, fire safety clearances, and compliance with local municipal regulations applicable to IT operations."
      },
      {
        title: "Can you assist with specialized requirements like data centers or server rooms?",
        content: "We can identify properties suitable for data centers including adequate power supply, cooling systems, security infrastructure, and compliance with data center regulations and standards."
      },
      {
        title: "What about cost optimization for IT workspace requirements?",
        content: "Our data-driven approach helps optimize costs by analyzing location benefits, infrastructure availability, operational expenses, and total cost of ownership to ensure you get maximum value for your IT workspace investment."
      }
    ],
    commercial: [
      {
        title: "What types of commercial properties do you specialize in?",
        content: "We handle office buildings, retail spaces, malls, commercial complexes, business parks, showrooms, hotels, restaurants, and mixed-use developments across Coimbatore. Our portfolio covers both lease and purchase options for various commercial needs."
      },
      {
        title: "How do you evaluate commercial properties for investment potential?",
        content: "Our feasibility studies include rental yield analysis, capital appreciation potential, occupancy rates in the area, infrastructure development plans, and market demand assessment to ensure sound commercial investments."
      },
      {
        title: "What's your process for tenant and landlord matching?",
        content: "We maintain a database of quality tenants and property owners. Our matching process considers business compatibility, lease terms, location preferences, and long-term stability to create mutually beneficial arrangements."
      },
      {
        title: "How do you ensure proper approvals for commercial buildings?",
        content: "Our liaison services verify building plan approvals, occupancy certificates, fire safety clearances, lift approvals, parking permissions, and compliance with commercial building regulations before transactions."
      },
      {
        title: "Do you provide market analysis for different commercial sectors?",
        content: "Yes, we provide sector-specific analysis for retail, office, hospitality, and other commercial segments including demand-supply dynamics, rental trends, and growth prospects in different areas of Coimbatore."
      }
    ],
    development: [
      {
        title: "Do you help developers identify prime land parcels for new projects?",
        content: "Yes, we specialize in location anchoring for developers, using data-driven insights to identify breakthrough sites with optimal development potential. Our market analysis helps you secure land in high-demand micromarkets.",
      },
      {
        title: "What kind of feasibility studies do you provide for development projects?",
        content: "Our comprehensive feasibility studies include market analysis, demand assessment, optimal product mix recommendations, regulatory compliance requirements, cost-benefit analysis, and timeline planning for successful project execution."
      },
      {
        title: "Do you assist with all statutory approvals for development projects?",
        content: "Yes, our liaison services handle building plan approvals, layout sanctions, environmental clearances, DTCP permissions, RERA registrations, and all regulatory requirements from project conception to completion."
      },
      {
        title: "What's your role in the project lifecycle from land acquisition to sales?",
        content: "We provide end-to-end support including land sourcing, approvals coordination, market analysis, product planning, RERA compliance, and can connect you with marketing partners for project sales and promotion."
      },
      {
        title: " Can you assist with land aggregation for large-scale development projects?",
        content: "Yes, we excel at land aggregation services, coordinating with multiple landowners, ensuring clear titles, structuring acquisition terms, and assembling large parcels suitable for comprehensive development projects."
      }
    ],
    liaison: [
      {
        title: "Which government departments do you coordinate with for property approvals?",
        content: "We coordinate with 40+ departments including DTCP, Corporation, Municipal bodies, Revenue Department, Fire Department, Water Board, Electricity Board, Pollution Control Board, Forest Department, and various regulatory authorities for comprehensive approvals."
      },
      {
        title: "Do you provide legal opinion services for property transactions?",
        content: "Yes, we offer comprehensive legal opinions including title verification, encumbrance certificate analysis, government pleader opinions, and legal due diligence to ensure clear property titles and compliance."
      },
      {
        title: "Can you help with property disputes and regularization issues?",
        content: "Our services include plot regularization, unapproved layout regularization, dispute resolution coordination, and liaison with revenue officials to resolve property-related issues and ensure clear titles."
      },
      {
        title: "How do you ensure transparency in the liaison process?",
        content: "We provide regular updates, maintain detailed documentation, share timeline progress, and ensure you're informed at every stage. Our transparent approach includes cost breakdowns and realistic timeline commitments."
      },
      {
        title: " What's your success rate with complex approval cases?",
        content: "With 15+ years of experience and expertise across 1000+ acres of land use changes and 5 million sq ft of building approvals, we have a high success rate even with complex cases requiring multiple departmental coordination."
      }
    ],
    dtcp: [
      {
        title: "What types of buildings require DTCP approval in Tamil Nadu?",
        content: "DTCP approval is required for residential buildings above 10,000 sq ft, commercial buildings above 2,000 sq ft, industrial buildings, educational institutions, healthcare facilities, and any multi-story construction depending on local jurisdiction."
      },
      {
        title: "What's the difference between DTCP approval and local body building license?",
        content: "DTCP provides planning permission under Town & Country Planning Act, while building license is from local bodies. Most projects require both approvals - DTCP for planning compliance and local body license for construction permission."
      },
      {
        title: "How do you handle drawing iterations and design changes during the approval process?",
        content: "Our team coordinates with architects for any required design modifications based on DTCP queries. We manage the iteration process, ensuring drawings comply with regulations while maintaining your design intent and maximizing space utilization."
      },
      {
        title: "What's your process for handling DTCP queries and clarifications?",
        content: "We maintain regular coordination with DTCP officials, promptly address any queries, provide additional documentation when required, and ensure clear communication throughout the approval process to avoid delays."
      },
      {
        title: "Do you verify all prerequisite clearances before DTCP submission?",
        content: "Yes, our feasibility study includes verification of land use compliance, property tax status, encumbrance certificate review, and ensuring all prerequisite documents are in order before DTCP submission."
      }
    ],
    landuse: [
      {
        title: "What types of land can be converted from agricultural to non-agricultural use?",
        content: 'Most agricultural lands can be converted except public water bodies, government lands, temple/wakf properties, encroached lands, areas under high-tension lines, and lands officially classified as fit for cultivation by agricultural authorities.'
      },
      {
        title: "Do you handle conversions for all purposes - residential, commercial, industrial, medical?",
        content: "Yes, we handle land use conversions for residential, commercial, industrial, medical, educational, and other non-agricultural purposes. Each category has specific requirements which our experienced team manages efficiently."
      },
      {
        title: "What's the difference between wetland and dryland conversion procedures?",
        content: "Wetland conversions require Collector's prior concurrence and detailed agricultural impact assessment, while dryland conversions need Joint Director of Agriculture's report. Wetlands typically take longer due to additional scrutiny and environmental considerations."
      },
      {
        title: "What site inspections are involved in the land use conversion process?",
        content: "The Collector conducts site inspections with DTCP officials to verify land status, existing development compatibility, irrigation sources, cultivation status, and impact on agricultural productivity and drainage systems."
      },
      {
        title: "Do you ensure the conversion order is properly recorded in revenue records?",
        content: "Absolutely! We coordinate with revenue officials to ensure proper entries are made in Patta, Chitta, and other revenue records after the conversion order is issued, completing the legal transformation of land classification."
      }
    ],
    layoutapproval: [
      {
        title: "What's the minimum land area required for layout approval in Tamil Nadu?",
        content: "While there's no specific minimum, layouts typically start from 1 acre. The key requirements are proper road connectivity, drainage provisions, open space reservations (OSR), and compliance with local development regulations and density norms."
      },
      {
        title: "What percentage of land must be reserved for roads and open spaces in layouts?",
        content: "Generally, 15-30% for roads depending on plot sizes, 10% for open space reservation (OSR), and additional reservations for utilities. Exact percentages vary based on local regulations and DTCP guidelines for the specific area."
      },
      {
        title: "How do you optimize plot layouts to maximize saleable area?",
        content: "Our design team creates efficient layouts maximizing saleable plots while ensuring regulatory compliance. We optimize road widths, minimize wastage areas, plan proper drainage systems, and strategically locate common facilities."
      },
      {
        title: "What approvals are required from HACA for layout projects?",
        content: "If your layout is near hills or environmentally sensitive areas, HACA (Hill Area Conservation Authority) NOC is required. We handle HACA coordination, environmental compliance documentation, and necessary site presentations to expedite approvals.",
      },
      {
        title: "What's the validity of layout approval and renewal process?",
        content: "Layout approvals typically have 3-5 years validity depending on the approving authority. We assist with renewal applications if needed and coordinate with authorities to maintain approval validity throughout your development timeline.",
      }
    ],
    haca: [
      {
        title: " When is HACA NOC required for property development in Tamil Nadu?",
        content: "HACA NOC is required for any development within prescribed distances from hills, forests, water bodies, and other environmentally sensitive areas as defined by the Hill Area Conservation Authority regulations."
      },
      {
        title: "What environmental studies are required for HACA applications?",
        content: "Requirements may include environmental impact assessments, biodiversity studies, water source impact analysis, soil erosion assessments, and drainage impact evaluations depending on the project scale and proximity to sensitive areas."
      },
      {
        title: "Can you help with HACA approvals for different types of developments?",
        content: "We handle HACA NOCs for residential projects, commercial developments, industrial establishments, educational institutions, healthcare facilities, and infrastructure projects in hill areas and environmentally sensitive zones."
      },
      {
        title: "What site documentation is required for HACA NOC applications?",
        content: "Required documentation includes detailed site surveys, environmental compliance reports, drainage impact studies, landscape preservation plans, and coordination with local environmental authorities for comprehensive assessment."
      },
      {
        title: "Do you ensure ongoing environmental compliance after HACA approval?",
        content: "Yes, we provide guidance on maintaining environmental compliance conditions, coordinate periodic inspections if required, and ensure ongoing adherence to environmental protection measures specified in the HACA clearance."
      }
    ],
    registration: [
      {
        title: "What's the current stamp duty and registration charges in Tamil Nadu?",
        content: "Stamp duty is 7% of property value (market value or guideline value, whichever is higher) and registration fee is 4% of property value. Additional document writing charges vary based on property complexity and value.",
      },
      {
        title: "Can you explain the difference between guideline value and market value for registration?",
        content: "Guideline value is the government-fixed minimum value for registration purposes, while market value is the actual transaction price. Registration must be done on whichever is higher, affecting your stamp duty calculation."
      },
      {
        title: "Do you handle registrations for both cash and loan transactions?",
        content: "Yes, we handle registrations for both cash purchases and bank-financed transactions. Our team coordinates with banks for loan documentation and ensures all papers are ready for smooth registration completion."
      },
      {
        title: "What's your role in preventing document errors during registration?",
        content: "Our team conducts thorough document verification, checks all names, addresses, survey numbers, and transaction details for accuracy. We coordinate pre-registration reviews to prevent errors that could complicate future transactions."
      },
      {
        title: "How do you handle registration for NRI property purchases?",
        content: "We coordinate NRI registrations including Power of Attorney documentation, FEMA compliance verification, and coordination with authorized representatives. All NRI-specific legal requirements are properly handled."
      }
    ],
    digitalsurvey: [
      {
        title: "What types of digital surveys do you provide and what's the accuracy level?",
        content: "We provide ALTA/ACSM land surveys, topographic surveys, boundary surveys, foundation marking, volumetric surveys, and as-built surveys using advanced digital equipment with centimeter-level accuracy for precise measurements and mapping.",
      },
      {
        title: "How quickly can you complete a digital survey compared to traditional methods?",
        content: "Digital surveys are completed 50-70% faster than traditional methods. Typical residential plots take 1 day, while larger commercial or industrial sites may take 1 -2 days depending on complexity and size."
      },
      {
        title: " What digital formats do you provide for survey deliverables?",
        content: "Survey outputs are available in CAD, PDF formats, and other industry-standard formats compatible with architectural software, engineering applications, and project management systems for seamless workflow integration."
      },
      {
        title: "Do you provide 3D mapping and contour surveys for construction planning?",
        content: "Yes, our topographic surveys include detailed 3D terrain modeling, contour mapping, elevation analysis, and digital terrain models essential for architectural planning, drainage design, and construction feasibility studies."
      },
      {
        title: " Can you help resolve boundary disputes with accurate survey data?",
        content: "Our boundary surveys provide precise property line demarcation, coordinate with government records verification, and provide legally valid survey documentation that can be used for resolving property boundary disputes."
      }
    ],
    "agri-propertymanagement": [
      {
        title: "1. Do you farm the land for me?",
        content: "No. We look after your land, advise on cultivation, and supervise the people who do the work. The decisions, and the land, stay yours."
      },
      {
        title: "2. I live abroad. Can I sign up without coming to India?",
        content: "Yes. Everything from the first conversation to your reports happens over phone, WhatsApp and email."
      },
      {
        title: "3. What happens if you find encroachment?",
        content: "We inform you promptly with photos and the boundary record, well before you would have noticed it yourself. If you want to act, our in-house legal and liaison teams can take it forward."
      },
      {
        title: "4. My documents are incomplete or unclear. Can you still help?",
        content: "Yes, and that's often where we start. Our audit notes what's missing, and our liaison team can help put patta, chitta and FMB records in order."
      },
      {
        title: "5. How often will you visit, and how will I hear from you?",
        content: "You choose the visit frequency with your plan. After every visit you receive photos and a written report on WhatsApp, with one dedicated contact for any questions."
      },
      {
        title: "6. Is there a minimum land size?",
        content: "Our service works best for land of 10 acres and above. For smaller holdings, talk to us and we can tell you how we can go ahead with it."
      },
      {
        title: "7. What does it cost?",
        content: "It depends on the size and location of your land and the level of care you choose. We can give you exact quote once the first land audit is done by the team."
      },
      {
        title: "8. What if I decide to sell or develop the land later?",
        content: "Lands & Lands can help with that too, through our resale, plotted development and registration services, with the land's full record already in hand."
      }
    ]


  };

  console.log(accordionData.apartment)

  return (
    <>
      <section className="bg-grey">
        <div className="max-w-7xl mx-auto px-4 md:px-8 py-10 sm:py-32">

          <div className='my-[50px]'>
            <h2 className="heading !font-noto" data-aos="fade-up">Frequently Asked Questions</h2>
            <hr className='border-yellow border-[2px] w-[87px] mx-auto my-[25px]' data-aos="fade-up" data-aos-duration="800" />
          </div>

          <div className="md:max-w-4xl mx-auto h-fit border-2 border-grey rounded-sm bg-white shadow-lg mb-8 lg:py-12 px-8" data-aos="fade-up">

            {accordionData[key].map((data, index) => {
              return (
                <AccordionItem
                  key={index}
                  open={index === open}
                  title={data.title}
                  desc={data.content}
                  list1={data.list1}
                  list2={data.list2}
                  list3={data.list3}
                  list4={data.list4}
                  list5={data.list5}
                  list6={data.list6}
                  toggle={() => toggle(index)}
                />
              );
            })}
          </div>
        </div>
      </section>
    </>
  );
}

export default FAQ;
